import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, timer, EMPTY } from 'rxjs';
import { switchMap, catchError, filter } from 'rxjs/operators';
import { url_servicios } from 'src/app/config/config';
import { NotificationSummary } from '../models/ticket.model';
import { ApiV2Response } from '../models';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private readonly http = inject(HttpClient);
  private readonly authService = inject(AuthService);

  private notificationSummary$ = new BehaviorSubject<NotificationSummary>({
    unread_tickets_count: 0,
    unread_responses_count: 0,
    new_tickets_count: 0,
    total_unread: 0
  });

  constructor() {
    this.startPolling();
  }

  getNotificationSummary(): Observable<NotificationSummary> {
    return this.notificationSummary$.asObservable();
  }

  triggerRefresh(): void {
    this.refreshNotifications().subscribe({
      next: (response) => {
        if (response?.data) {
          this.notificationSummary$.next(response.data);
        }
      },
      error: () => {}
    });
  }

  refreshNotifications(): Observable<ApiV2Response<NotificationSummary>> {
    const url = `${url_servicios}/v2/tickets/notifications/summary`;
    return this.http.get<ApiV2Response<NotificationSummary>>(url).pipe(
      catchError(error => {
        console.error('Error fetching notifications:', error);
        throw error;
      })
    );
  }

  markTicketAsRead(ticketId: number): Observable<ApiV2Response<unknown>> {
    const url = `${url_servicios}/v2/tickets/${ticketId}/mark-read`;
    return this.http.post<ApiV2Response<unknown>>(url, {});
  }



  private startPolling(): void {
    timer(0, 90000) // Poll immediately, then every 90 seconds
      .pipe(
        // Only poll when user is authenticated
        filter(() => this.authService.isAuthenticated()),
        switchMap(() => this.refreshNotifications()),
        catchError(error => {
          console.error('Notification polling error:', error);
          // Return empty observable to continue polling
          return EMPTY;
        })
      )
      .subscribe({
        next: (response) => {
          if (response?.data) {
            this.notificationSummary$.next(response.data);
          }
        },
        error: (error) => console.error('Notification subscription error:', error)
      });
  }
}
